import { CSSProperties } from 'react';

import { AppColors } from './../../theme';

type CollapseStyles = {
  collapseHeader: CSSProperties;
  collapseHeader__count: CSSProperties;
  collapseHeader__title: CSSProperties;
  collapseHeader__subtitle: CSSProperties;
  collapseIcon: CSSProperties;
  collapseHeader__row: CSSProperties;
  collapseBody: CSSProperties;
};

const styles: CollapseStyles = {
  collapseHeader: {
    borderRadius: '8px',
    border: `1px solid ${AppColors.VA.NEUTRALS._20_}`,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 16px',
    marginTop: '16px',
    backgroundColor: AppColors.VA.NEUTRALS._10_
  },
  collapseHeader__count: {
    height: '30px'
  },
  collapseHeader__title: {
    color: AppColors.VA.NEUTRALS._90_,
    marginBottom: '12px'
  },
  collapseHeader__subtitle: {
    color: AppColors.VA.NEUTRALS._60_,
    marginBottom: '10px'
  },
  collapseHeader__row: {
    height: '100%',
    alignItems: 'center'
  },
  collapseIcon: {
    fontSize: '18px'
  },
  collapseBody: {
    border: 'none',
    padding: '0',
    backgroundColor: AppColors.VA.NEUTRALS.WHITE
  }
};

export default styles;
